// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_la-0";